<template>
  <div
    class="data-charts-edit w-full flex flex-col gap-2 items-center justify-center rounded-2 h-[100px] select-none cursor-pointer"
    :style="{ backgroundColor: themeVars.primary6, color: themeVars.primary3, fontFamily: 'var(--font-family)' }"
    @click="setComponentEditMode(ComponentTypes.DataCharts, id)"
  >
    <CIcon :color="themeVars.primary4" fa-type="fa-kit" :icon="ComponentIcon.DataCharts" size="36px" />
    <span>{{ t('canvasUI.canvasBuilder.dataCharts.addYourChart') }}</span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import { ComponentIcon, ComponentTypes } from '@canvas-builder/types/canvas'
import useCanvas from '@canvas-builder/composables/useCanvas'

defineProps<{
  id: string
}>()

const { t } = useI18n()
const themeVars = useThemeVars()
const { setComponentEditMode } = useCanvas()
</script>
